// extracted by mini-css-extract-plugin
module.exports = {"btns":"OrderLevel_btns__2Zop4","editBtn":"OrderLevel_editBtn__1hVWJ","deleteBtn":"OrderLevel_deleteBtn__3Jkh1"};